import Bid, { BID } from "./bid";

export enum CONTRACT {
    NONE = -1,
    PASSEDOUT = 0
}

export enum PENALTY {
    NONE = 1,
    DOUBLE = 2,
    REDOUBLE = 3,
}

export default class Contract extends Bid {
    penalty = PENALTY.NONE

    constructor(c?: Contract) {
        super();
        if (c)
            this.set(c);

    }

    static fromObject(obj: any | Contract) {
        const c = new Contract();
        c.height = obj.height;
        c.suit = obj.suit;
        c.penalty = obj.penalty;
        // alert stuff not really needed for contract.
        c.alert = obj.alert ?? false;
        c.explanation = obj.explanation ?? "";
        c.hideExplanation = obj.hideExplanation ?? false;
        return c;
    }

    static withInt(serverInt: number) {
        const contract = new Contract();
        contract.setInt(serverInt);
        return contract;
    }

    override clone() {
        return Contract.fromObject(this);
    }

    override set(c: Contract) {
        super.set(c)
        this.penalty = c.penalty;
    }

    setFrom(b: Bid, penalty: PENALTY) {
        super.set(b)
        this.penalty = penalty
    }

    isPlayable() { return this.getInt() > 0 && this.getInt() < BID.PASS; }
    isPassedOut() { return this.getInt() == CONTRACT.PASSEDOUT; }
    isDoubled() { return this.penalty === PENALTY.DOUBLE; }
    isRedoubled() { return this.penalty === PENALTY.REDOUBLE; }
    hasPenalty() { return this.penalty !== PENALTY.NONE; }

    override isValid(): boolean {
        return (super.isValid() || (this.height === 0 && this.suit === 0)) // contract pass
            && this.height !== 8;
    }

    override toString(): string {
        let s = "-";

        if (this.isPlayable()) {
            s = super.toStringWithoutAlert();

            if (this.isDoubled()) {
                s += "X";
            } else if (this.isRedoubled()) {
                s += "XX";
            }
        } else if (this.isPassedOut()) {
            s = "PASSED_OUT";
        }

        return s;
    }
}